<script>
	import { createEventDispatcher, onMount } from "svelte";
	import { Table } from "sveltestrap";
	import CustomTableLink from "./CustomTableLink.svelte";
	import CustomTableDate from "./CustomTableDate.svelte";
	import CustomTableActions from "./CustomTableActions.svelte";
	import CustomTableStatus from "./CustomTableStatus.svelte";
	import Pagination from "../CustomPaginate/Pagination.svelte";
	import {
		caseExportEnabled,
		caseExportList,
		totalRecords,
	} from "src/store/store";
	import LoaderContainer from "../Loader/LoaderContainer.svelte";
	import CustomTableMasterData from "./CustomTableMasterData.svelte";
	import CustomTableIndex from "./CustomTableIndex.svelte";
	import queryString from "query-string";
	import CustomTableJoinColumn from "./CustomTableJoinColumn.svelte";
	import CustomTableCheckBox from "./CustomTableCheckBox.svelte";
	import CustomTableCaseActivities from "./CustomTableCaseActivities.svelte";

	export let columns = [];
	export let rows = [];
	export let emptyMessage = "No data to display";
	export let useNavigation = false;
	export let noHeaders = false;
	export let borderless = false;
	export let hover = true;

	let sortColumn = "";
	let sortDirection = "descending"; // display descending by default

	const dispatch = createEventDispatcher();

	onMount(() => {
		const params = queryString.parse(window.location.search);
		if (params.sortCol !== undefined) {
			sortColumn = params.sortCol;
		}
		if (params.sortDir !== undefined) {
			sortDirection = params.sortDir;
		}
	});

	function toggleSort(column) {
		const url = new URL(window.location.href);

		sortDirection =
			sortDirection === "ascending" ? "descending" : "ascending";
		sortColumn = column;

		dispatch("sort", { column, direction: sortDirection });

		url.searchParams.set("sortCol", sortColumn);
		url.searchParams.set("sortDir", sortDirection);
		window.history.pushState({}, "", url);
	}

	function checkAllCases(e) {
		const checkboxes = document.querySelectorAll(
			'tbody input[type="checkbox"]'
		);
		checkboxes.forEach((checkbox) => {
			checkbox.checked = e.target.checked;
		});
		if (!e.target.checked) {
			caseExportList.set([]);
			return;
		} else {
			caseExportList.set(rows.map((row) => row["caseNo"]));
		}
	}

	let columnComponents = {
		link: CustomTableLink,
		actions: CustomTableActions,
		date: CustomTableDate,
		status: CustomTableStatus,
		masterdata: CustomTableMasterData,
		index: CustomTableIndex,
		joinColumn: CustomTableJoinColumn,
		checkbox: CustomTableCheckBox,
		caseActivity: CustomTableCaseActivities,
	};
</script>

<LoaderContainer>
	<Table responsive={!borderless} {hover} {borderless}>
		{#if !noHeaders}
			<thead>
				<tr>
					{#each columns as { label, key, type, sortCol, event }}
						<th>
							{#if type === "checkbox" && $caseExportEnabled}
								<input
									type="checkbox"
									style="width: 13%"
									name={key}
									on:change={(e) => {
										checkAllCases(e);
									}}
								/>
							{/if}
							{label}
							{#if type === "date" && sortCol}
								<i
									role="button"
									on:click={() => toggleSort(sortCol, event)}
									>{#if sortDirection === "descending"}
										<img
											src="/assets/icon-sort-up-thin.svg"
											alt="icon-sort-up"
										/>
									{:else}
										<img
											src="/assets/icon-sort-down-thin.svg"
											alt="icon-sort-down"
										/>
									{/if}
								</i>
							{/if}
						</th>
					{/each}
				</tr>
			</thead>
		{/if}
		<tbody>
			{#each rows as row, index}
				<tr on:click={() => dispatch("rowClick", row)}>
					{#each columns as { key, type, event, action, options, format, className, ...rest }}
						<td style="max-width: fit-content;">
							{#if columnComponents[type]}
								<svelte:component
									this={columnComponents[type]}
									{row}
									{key}
									{event}
									{action}
									{options}
									{format}
									{className}
									{...rest}
									index={index + 1}
								/>
							{:else}
								{row[key] || "-"}
							{/if}
						</td>
					{/each}
				</tr>
			{/each}
			{#if rows.length === 0}
				<tr>
					<td
						colspan={columns.length}
						class="text-center empty-message"
					>
						{emptyMessage}
					</td>
				</tr>
			{/if}
		</tbody>
	</Table>
	<Pagination totalRecord={$totalRecords} {useNavigation} />
</LoaderContainer>

<style>
	.empty-message {
		font-weight: bold;
	}

	:global(.table-borderless td, .table-borderless th, .table-borderless tr) {
		border: none !important;
	}
</style>
